import React, {Suspense, useEffect} from "react";

import Section from "../../layouts/core/Section";
import {
  Header,
  HeaderGroup,
  HeaderGroupCenter,
  HeaderGroupLeft,
  HeaderGroupRight,
} from "../../layouts/core/Header";
import Title from "../../layouts/core/Title";
import SpinnerComponent from "../../components/commons/SpinnerComponent";
import {Col, Row} from "react-bootstrap";
import {Sidebar} from "../../components/media-library/styles";
import Filter from "../../components/media-library/components/FilterSidebar/Filter";
import DeletedAssetFilter from "./DeletedAssetFilter";
import DeletedMediaFiles from "./DeletedMediaFiles";
import BulkEditDeletedAssets from "./BulkEditDeletedAssets";
import ReelerButton from "../../components/commons/ReelerButton";
import {useDispatch} from "react-redux";
import {BulkEditReset} from "../../redux/bulk-edit/bulkEdit.actions";
import RestoreAssets from "./RestoreAssets";
import {clearFilter} from "../../redux/filter/filter.actions";

export default function DeletedAssetPage() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Reset selected bulk edit
    dispatch(BulkEditReset());
    dispatch(clearFilter());
  }, []);
  return (
    <Section>
      <Header>
        <HeaderGroup>
          <HeaderGroupLeft>
            <Title>Deleted assets</Title>
          </HeaderGroupLeft>
          <HeaderGroupCenter>
            <BulkEditDeletedAssets />
          </HeaderGroupCenter>
          <HeaderGroupRight>
            <RestoreAssets />
          </HeaderGroupRight>
        </HeaderGroup>
      </Header>

      <Row className="mx-0 position-relative">
        <Sidebar $show={true} sm={12} md={3}>
          <DeletedAssetFilter />
        </Sidebar>
        <Col className="px-0">
          <div
            style={{
              margin: "16px 1.25rem",
            }}
          >
            <Suspense fallback={<SpinnerComponent />}>
              <DeletedMediaFiles />
            </Suspense>
          </div>
        </Col>
      </Row>
    </Section>
  );
}
